import React from 'react';
import axios from "../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import {
    Button,
    Card,
    CardBody,
    Input,
    Row,
    Alert,
    InputGroupAddon,
    InputGroup,
    FormGroup,
    Label,
    Collapse,
    CardTitle
} from "reactstrap";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {Colxx} from "../../../../components/common/CustomBootstrap";
import {Table} from "../../../../components/table/Table";

class ManageCustomerAddress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            //provinces: this.props.provinces ? this.props.provinces : [],
            currentCustomer: this.props.currentCustomer,
            customerAddresses: [],
            customerAddressEditMode: false,
            cities: [],
            telephone: null,
            mobile: null,
            CustomerAddressId: null,
            selectedProvince: null,
            selectedCity: null,
            postalCode: null,
            address: null,
            collapse: true
        }
        
    }

    componentDidMount() {
       // console.log(this.props.currentCustomer);
        this.loadProvinces();
        this.GetCustomerAddressByCustomerId();
    }
    loadProvinces = () => {
        axios.get('/api/v1/provinces/GetAll')
            .then((res) => {
                this.setState({ provinces: res.data.data });
            })
            .catch((error) => {
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    loadCities = (Id, cityId) => {
        this.setState({ cities: [] });
        let provinceId = Id!==null? this.state.selectedProvince !== null ? this.state.selectedProvince.provinceId : null:Id;
        axios.get('api/v1/cities/GetCityByProvinceId/' + provinceId)
       
            .then((res) => {
                this.setState({ cities: res.data.data });
                if (Id !== null && Id !== undefined && cityId !== null && cityId !== undefined) {
                    res.data.data.map((v) => {
                        if (v.cityId === cityId) {
                            this.setState({
                                selectedCity: v
                            })
                        }
                        return null
                    });
                }
            })
            .catch((error) => {
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    GetCustomerAddressByCustomerId = () => {
        this.props.showSpinner();
        axios.get('/api/v1/customer-addresses/GetCustomerAddressByCustomerId?CustomerId=' + this.state.currentCustomer.id)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ customerAddresses: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };



    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({
                
                currentCustomer: this.props.currentCustomer
            });
        }
    }
    InquiryPostalCode = (postalCode) => {
        this.props.showSpinner();
        axios.get('/api/v1/customers/InquiryPostalCode?postalcode=' + toEnglishNumbers(postalCode))
            .then((res) => {
                this.props.hideSpinner();
                let response = res.data.data.result;
                if (response.isSuccessful) {
                    this.setState({
                        address: response.fullAddress,
                        editAddress: response.fullAddress
                    });
                } else {
                    this.setState({ fullName: '' });
                    this.props.showAlert('کد پستی معتبر نمی‌باشد', 'error');
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    }; 
    validate = () => {
        this.props.closeSweetAlert();

        let error = [];
        if (this.state.address === null || this.state.address.length < 1) {
            error.push('وارد كردن آدرس الزامی میباشد.');
        }
        if (this.state.selectedCity === null) {
            error.push('انتخاب شهر الزامي میباشد.');
        }

        this.setState({errors: error});
        if (error.length === 0) {
            if (this.state.customerAddressEditMode) {
                this.editCustomerAddress();
            } else {
                this.addCustomerAddress();
            }
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    }; 
    addCustomerAddress = () => {
        let request = {
            cityId: this.state.selectedCity.cityId ,
            Address: toEnglishNumbers(this.state.address),
            Telephone: toEnglishNumbers(this.state.telephone), 
            Mobile: toEnglishNumbers(this.state.mobile),
            PostalCode: toEnglishNumbers(this.state.postalCode),
            CustomerId: this.state.currentCustomer.id
        };

        this.props.showSpinner();
        axios.post('/api/v1/customer-addresses/AddCustomerAddress', request)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, 'success');
                this.resetEdit();
                this.GetCustomerAddressByCustomerId();
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            })
    }; 
    showEditCustomerAddressPortlet = (address) => {
        this.setState({
            customerAddressEditMode: true,
            cities: [],
            currentCustomer: address,
            selectedCity: address.city,
            postalCode: address.postalCode,
            address: address.address,
            telephone: address.telephone,
            mobile: address.mobile,
            CustomerAddressId: address.id,
            
        });
      
        this.state.provinces.map((v) => {
            if (v.provinceId === address.provinceId) {
                this.setState({
                    selectedProvince: v
                }, () => this.loadCities(address.provinceId, address.cityId))
            }
            return null
        });
        

         
    };
    

    editCustomerAddress = () => {
        let model = {
             Id: this.state.CustomerAddressId,
            cityId: this.state.selectedCity.cityId,
            Address: toEnglishNumbers(this.state.address),
            Telephone: toEnglishNumbers(this.state.telephone), 
            Mobile: toEnglishNumbers(this.state.mobile),
            PostalCode: toEnglishNumbers(this.state.postalCode),
            CustomerId: this.state.currentCustomer.id,
        };

        this.props.showSpinner();
        axios.post('/api/v1/customer-addresses/UpdateCustomerAddress', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, 'success');
                this.resetEdit();
                this.GetCustomerAddressByCustomerId();
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            })
    }
    resetEdit = () => {
        this.setState({
            customerAddressEditMode: false,
            cities: [],
            selectedProvince: null,
            selectedCity: null,
            postalCode: "",
            address: "",
            telephone: "",
            mobile: "",
            
        });
    };

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value },
            () => {
                if (name === "selectedProvince") {
                    if (value !== undefined && value !== null)
                    {
                        this.setState({
                            selectedCity: null 
                        },() => this.loadCities())
                        
                    }
                    else {
                        this.setState({
                            selectedCity: null, cities: []
                        })
                    }
                }
                
            });
    };

    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody>
                    <CardTitle> 
                                        {this.state.customerAddressEditMode === true ?
                                            "ویرایش آدرس"
                                            :
                                            "افزودن آدرس"
                                        }
                    </CardTitle>
                                <div className="p-4 pt-5 border d-flex flex-column">
                                <div className="d-flex flex-md-row flex-column flex-wrap">
                                    <FormGroup className="w-md-25 w-100 px-1" >
                                        <Label>استان</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="selectedProvince"
                                            value={this.state.selectedProvince}
                                            options={this.state.provinces}
                                            getOptionLabel={(option) => option.provinceName}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedProvince")}
                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                        />
                                    </FormGroup>

                                    <FormGroup className="w-md-25 w-100 px-1" >
                                        <Label>شهر</Label>
                                        <Autocomplete
                                            clearText={"حذف"}
                                            closeText={"بستن"}
                                            noOptionsText={"در حال دریافت اطلاعات.."}
                                            openText={"باز کردن"}
                                            className="react-select__control"
                                            id="selectedCity"
                                            value={this.state.selectedCity}
                                            options={this.state.cities}
                                            getOptionLabel={(option) => option.cityName}
                                            onChange={(e, v) => this.selectHandleChange(e, v, "selectedCity")}
                                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                        />
                                    </FormGroup>

                                    <FormGroup className="w-md-25 w-100 px-1">
                                        <Label className="d-flex">کد پستی</Label>
                                        <InputGroup className="mb-3">
                                            <Input value={this.state.postalCode} maxLength={11}
                                                   onChange={(e) => this.setState({postalCode: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                                            <InputGroupAddon addonType="append" onClick={() => this.InquiryPostalCode(this.state.postalCode)}>
                                                <span className="input-group-text">
                                                    <i className="fa fa-search" aria-hidden="true"/>
                                                </span>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </FormGroup>

                                    <FormGroup className="w-md-25 w-100 px-1">
                                        <Label>آدرس</Label>
                                        <Input value={this.state.address} type="textarea" maxLength={500}
                                               onChange={(e) => this.setState({address: e.target.value})}/>
                                    </FormGroup>

                                    <FormGroup className="w-md-25 w-100 px-1">
                                        <Label>تلفن</Label>
                                        <Input value={this.state.telephone} maxLength={11}
                                               onChange={(e) => this.setState({telephone: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                                    </FormGroup>

                                    <FormGroup className="w-md-25 w-100 px-1">
                                        <Label>موبایل</Label>
                                        <Input value={this.state.mobile} maxLength={11}
                                               onChange={(e) => this.setState({mobile: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                                    </FormGroup>

                                    
                                </div>

                                <div className="d-flex mt-2 justify-content-center">
                                    {this.state.customerAddressEditMode ?
                                        <>
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2"
                                                        onClick={() => this.props.showSweetAlert("آیا از اطلاعات وارد شده مطمئن هستید؟", "", "warning", this.validate)}>
                                                    ذخیره
                                                </Button>
                                            </FormGroup>
                                            <FormGroup className="text-center">
                                                <Button color="danger" className="btn-lg mx-2"
                                                        onClick={this.resetEdit}>
                                                    لغو
                                                </Button>
                                            </FormGroup>
                                        </>
                                        :
                                        <FormGroup className="text-center">
                                            <Button color="primary" className="btn-lg mx-2"
                                                    onClick={() => this.props.showSweetAlert("آیا از اطلاعات وارد شده مطمئن هستید؟", "", "warning", this.validate)}>
                                                ذخیره
                                            </Button>
                                        </FormGroup>
                                    }
                                </div>
                            </div>

                            {this.state.errors.length === 0 ?
                                null
                                :
                                <div>
                                    {(this.state.errors.map((error, i) => {
                                        return (
                                            <Alert color="danger" key={i}>{error}</Alert>
                                        )
                                    }))}
                                </div>
                            }

                        <Table
                            tableHeaders={[
                                "شهر",
                                "آدرس",
                                "تلفن",
                                "موبایل", 
                                "کد پستی",
                                "ویرایش"
                            ]}

                            tableRow={this.state.customerAddresses}

                            tableData={[
                                address => {
                                    return address.cityName;
                                },
                                address => {
                                    return address.address;
                                },
                                address => {
                                    return address.telephone;
                                },
                                address => {
                                    return address.mobile;
                                },
                                 
                                address => {
                                    return address.postalCode;
                                },
                                address => {
                                    return (
                                        <Button outline color="primary" size="sm"
                                                onClick={() => this.showEditCustomerAddressPortlet(address)}>
                                            ویرایش
                                        </Button>
                                    );
                                }
                            ]}
                        />
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default ManageCustomerAddress;